import * as React from "react";
import PropTypes from "prop-types";
import { useRouter } from "next/router";

import { useABFlag } from "@lululemon/mwa-ab-testing/esm";
import {
  useActiveColor,
  useProductId,
} from "../../hooks/use-product-attributes";
import usePDPTranslations from "@lululemon/ecom-pdp/src/hooks/useTranslations";

import { ItemRecommendationCarousel } from "@lululemon/recommenders";
import { LinkProvider } from "@lululemon/ui-library";
import LinkGenerator from "@lululemon/ecom-common/src/lib/link-generator";
import { useIsYmlVerticalEnabled } from "../../hooks/use-features-enablement";
import { useDeviceType } from "@lululemon/ecom-site/src/util/with-device-characteristics";

export const useYouMayAlsoLike = (productId) => {
  const isYmlVerticalEnabled = useIsYmlVerticalEnabled();
  const {
    deviceType: { isDesktop },
  } = useDeviceType();
  const { code: activeColor } = useActiveColor();
  const shouldUseColorBasedRecommenders = useABFlag("pdpFusionColorRecomms");

  const offset = isYmlVerticalEnabled ? 4 : 0;
  const itemCount = isDesktop ? 4 : 8;

  const itemId = shouldUseColorBasedRecommenders
    ? `${activeColor}_${productId}`
    : productId;
  const modelId = shouldUseColorBasedRecommenders
    ? "VisualSimilarityModelV1"
    : "ProductModelV1";

  return {
    itemCount,
    itemId,
    modelId,
    offset,
  };
};

const YouMayAlsoLikeCarousel = ({ fusionExperimentVariant }) => {
  const productId = useProductId();
  const { locale } = useRouter();
  const translations = usePDPTranslations();

  const { itemCount, itemId, modelId, offset } = useYouMayAlsoLike(productId);

  return (
    <LinkProvider component={LinkGenerator}>
      <div
        className="wrapper lll-grid-padding OneLinkTx"
        data-testid="ymal-carousel"
      >
        <ItemRecommendationCarousel
          analyticsAttributes={{
            "data-lulu-track": "pdp-ymal-recommendation",
          }}
          analyticsId="recommendation:ymal"
          fusionExperimentVariant={fusionExperimentVariant || undefined}
          heading={translations.labels.youMayAlsoLike}
          itemCount={itemCount}
          itemId={itemId}
          locale={locale}
          modelId={modelId}
          offset={offset}
        />
      </div>
    </LinkProvider>
  );
};

YouMayAlsoLikeCarousel.propTypes = {
  fusionExperimentVariant: PropTypes.string,
};

YouMayAlsoLikeCarousel.defaultProps = {
  fusionExperimentVariant: "",
};

export default YouMayAlsoLikeCarousel;
